<template>
  <div class="templateList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="btnclick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
import Qs from 'qs'
import Url from '@/views/analyse/util/url'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import UPDATE from '@/components/page/update'
import DataUtil from '@/utils/dataUtil'

//发送类型
const sendTypeList = [
  {key:0, value:"自动短信"},
  {key:1, value:"通知短信"},
  {key:2, value:"营销短信"},
  {key:3, value:"手机号短信"},
]

export default {
  name: 'templateList',
  components: {
    FORM,
    tablePage,
    UPDATE
  },
  data() {
    return {
      queryData: {},
      /*form查询表单*/
      formData: {
        hasLable: true,
        cols: []
      },
      /*table查询记录*/
      pageData: {
        queryUrl: Url.sms.templateList,
        selection: true,
        sequence: false,
        method: 'get',
        cols: [
          { title: '发送类型', field: 'sendType', width: '100px', render: (data, full) => {return sendTypeList.find(e => e.key === data).value} },
          { title: '模板名称', field: 'templateName' },
          { title: '模板内容', field: 'templateContent' },
          { title: '备注', field: 'remark' },
          { title: '创建时间', field: 'createTime', width: '150px', render: (data, full) => {return DataUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')} },
          { title: '更新时间', field: 'updateTime', width: '150px', render: (data, full) => {return DataUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')} },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: window.$t('common.edit'),
                click: window.$t('common.edit'),
                type: 'primary',
                icon: 'el-icon-edit',
                auth: 'analyse:sms:editTemplate',
              },
            ]
          }
        ]
      },
      /*add或update浮窗表单*/
      updateData: {
        cols: []
      },
      /*其它*/
      selectData: {
        ids: ''
      },
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },

    /*form按钮点击事件*/
    formclick(clickName, data) {
      if (clickName == window.$t('common.search')) {
        data.status = 1
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)

      } else if (clickName == window.$t('common.addNew')) {
        //this.isNewRecord = true
        this.$refs.childUpdate.open()

      } else if (clickName == window.$t('common.hide')) {
        if (this.selectData.ids == "") {
          this.$message.error('未选取记录')
        } else {
          this.$confirm('确定隱藏已选取的记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.dataChange(Url.sms.templateHide, this.selectData, res => {
              if (res.code == 0) {
                this.$message.success('操作成功')
                this.$refs.childTable.defaultQueryData(this.queryData)
              } else {
                this.$message.error(res.message)
              }
            })
          }).catch(() => {})
        }
      }
    },

    /*table按钮点击事件*/
    btnclick(clickName, row) {
      if (clickName == window.$t('common.edit')) {
        //this.isNewRecord = false
        this.$refs.childUpdate.open(row)
      }
    },

    /*add或update提交数据触发事件*/
    submit(model) {
      this.dataChange(Url.sms.templateSave, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /*其它*/
    checkbox(row) {
      this.selectData.ids = row.map(key => key.id).join(",");
    },
    isEdit(model, col) {
      return model.id != undefined ? true : false
    },
  },
  created() {
    /*表单初始化*/
    this.formData.cols = [
      { title: '发送类型', field: 'sendType', type: 2, optionList: sendTypeList },
      { title: '模板名称', field: 'templateName' },
      { title: '模板内容', field: 'templateContent' },
      { click: window.$t('common.search'), icon: 'el-icon-search' },
      { click: window.$t('common.addNew'), icon: 'el-icon-circle-plus-outline', auth: 'analyse:sms:addTemplate' },
      { click: window.$t('common.hide'), icon: 'el-icon-delete', auth: 'analyse:sms:hideTemplate' },
    ]
    this.updateData.cols = [
      { title: '序号', field: 'id', hidden: true },
      { title: '发送类型', field: 'sendType', type: 2, optionList: sendTypeList, readonly: this.isEdit, required: true },
      { title: '模板名称', field: 'templateName', required: true },
      { title: '模板内容', field: 'templateContent', textType: 'textarea', required: true },
      { title: '备注', field: 'remark' },
    ]
  }

}
</script>
